var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapehero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1302,
    height: 110,
    viewBox: "0 0 1302 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_367)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_135_367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.460938C180.833 73.7943 434 -17.8724 651 31.0165C868 79.9054 1085 -11.7613 1302 22.4609V110.461H0V0.460938Z",
    fill: "#F5EDE0",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 50C162.75 20 361.667 88 596.75 55C831.833 22 1048.83 80 1302 52V110H0V50Z",
    fill: "url(#paint0_linear_135_367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 69.9998C235.083 43.9998 488.25 89.9998 723.333 65.9998C958.417 39.9998 1157.33 81.9998 1302 67.9998V110H0V69.9998Z",
    fill: "#F5EDE0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_367",
    x1: 0,
    y1: 42.1484,
    x2: 0,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EDE0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5EDE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1302,
    height: 110,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_135_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1302,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapehero);
export default __webpack_public_path__ + "static/media/Shape hero.a031cc8da02c1b34032ee7c1821c8bee.svg";
export { ForwardRef as ReactComponent };